export default defineNuxtPlugin((nuxtApp) => {
  if (typeof window === 'undefined') return;

  nuxtApp.provide('heicToAny', async (file: File): Promise<{ base64: Blob; file: File }> => {
    const libheif = await import('libheif-js/wasm-bundle');

    const uint8Array = new Uint8Array(await file.arrayBuffer());
    const decoder = new libheif.HeifDecoder();
    const images = decoder.decode(uint8Array);

    if (!images?.length) throw new Error('Failed to decode HEIF image');

    const image = images[0];
    const width = image.get_width();
    const height = image.get_height();

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d')!;
    const imageData = ctx.createImageData(width, height);

    await new Promise<void>((resolve, reject) => {
      image.display(imageData, (displayData: ImageData | null) => {
        if (!displayData) {
          reject(new Error('HEIF display failed'));
          return;
        }
        resolve();
      });
    });

    ctx.putImageData(imageData, 0, 0);

    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (b) => (b ? resolve(b) : reject(new Error('Canvas conversion failed'))),
        'image/jpeg',
        0.9,
      );
    });

    return {
      file: new File([blob], `${file.name.split('.')[0]}.jpeg`, { type: 'image/jpeg' }),
      base64: blob,
    };
  });
});
